import { render, staticRenderFns } from "./CgGoods.vue?vue&type=template&id=dee5f47c&scoped=true"
import script from "./CgGoods.vue?vue&type=script&lang=js"
export * from "./CgGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee5f47c",
  null
  
)

export default component.exports